import { useState, useEffect } from "react";
import Navbar from "@/components/Navbar";
import CountdownBanner from "@/components/CountdownBanner";
import HeroSection from "@/components/HeroSection";
import MeetMaskySection from "@/components/MeetMaskySection";
import PassportSection from "@/components/PassportSection";
import HowItWorksSection from "@/components/HowItWorksSection";
import WhatsIncludedSection from "@/components/WhatsIncludedSection";
import WhyFencingSection from "@/components/WhyFencingSection";
import GallerySection from "@/components/GallerySection";
import GradingSection from "@/components/GradingSection";
import WhatToWearSection from "@/components/WhatToWearSection";
import TimetableSection from "@/components/TimetableSection";
import HolidayReminderSection from "@/components/HolidayReminderSection";
import PricingSection from "@/components/PricingSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import FAQSection from "@/components/FAQSection";
import FinalCTASection from "@/components/FinalCTASection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import AskMaskyChatWidget from "@/components/AskMaskyChatWidget";
import { trackPageView } from "@/utils/analytics";

export default function LandingPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    trackPageView();
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      <CountdownBanner />
      <Navbar isScrolled={isScrolled} topOffset="top-[42px]" />
      <HeroSection />
      <MeetMaskySection />
      <PassportSection />
      <HowItWorksSection />
      <WhatsIncludedSection />
      <WhyFencingSection />
      <GallerySection />
      <GradingSection />
      <WhatToWearSection />
      <TimetableSection />
      <HolidayReminderSection />
      <PricingSection />
      <TestimonialsSection />
      <FAQSection />
      <FinalCTASection />
      <ContactSection />
      <Footer />
      <AskMaskyChatWidget />
    </div>
  );
}
